import { ref, readonly } from 'vue'

export const useScreenshotCapture = () => {
  const capturing = ref(false)

  const canvasToBlob = async (canvas) => {
    return new Promise((resolve) => {
      canvas.toBlob((blob) => resolve(blob), 'image/png', 1)
    })
  }

  const captureFullPage = async (options = {}) => {
    if (!import.meta.client) {
      return null
    }

    capturing.value = true

    try {
      const html2canvas = (await import('html2canvas')).default
      const totalHeight = document.body.scrollHeight
      const viewportHeight = window.innerHeight
      const viewportWidth = window.innerWidth

      const canvas = document.createElement('canvas')
      const context = canvas.getContext('2d')
      canvas.width = viewportWidth
      canvas.height = totalHeight

      let yOffset = 0

      while (yOffset < totalHeight) {
        window.scrollTo(0, yOffset)
        await new Promise(resolve => setTimeout(resolve, 100))

        const sectionCanvas = await html2canvas(document.body, {
          ignoreElements: options.ignoreElements || (() => false),
          foreignObjectRendering: false,
          useCORS: true,
          allowTaint: true,
          scale: window.devicePixelRatio || 1,
          logging: false,
          windowWidth: viewportWidth,
          windowHeight: viewportHeight,
          x: 0,
          y: yOffset,
          width: viewportWidth,
          height: Math.min(viewportHeight, totalHeight - yOffset),
          scrollX: 0,
          scrollY: yOffset
        })

        context.drawImage(sectionCanvas, 0, yOffset)
        yOffset += viewportHeight
      }

      window.scrollTo(0, 0)

      const blob = await canvasToBlob(canvas)
      return new File([blob], `screenshot-${Date.now()}.png`, { type: 'image/png' })
    } finally {
      capturing.value = false
    }
  }

  return {
    capturing: readonly(capturing),
    captureFullPage
  }
}
